module.exports = __webpack_public_path__ + "img/fst.c19e39ea.jpg";